import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const BEARER_KEY = "cbb-session-bearer";

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach Authorization header from localStorage fallback if present.
// This guarantees auth still works in browsers that block third-party cookies.
api.interceptors.request.use((config) => {
  try {
    const t = localStorage.getItem(BEARER_KEY);
    if (t) config.headers["Authorization"] = `Bearer ${t}`;
  } catch { /* no-op */ }
  return config;
});

export async function subscribe(email, source = "community") {
  const referrer =
    typeof window !== "undefined" ? window.location.pathname : null;
  const res = await api.post("/community/subscribe", {
    email,
    source,
    referrer,
  });
  return res.data;
}

export async function getCommunityStats() {
  const res = await api.get("/community/stats");
  return res.data;
}

// Fire on every quiz completion — anonymous and signed-in — so real event
// stats reflect actual reach (not just logged-in users). We swallow errors
// silently since a failed telemetry ping should never disrupt the reveal UX.
const QUIZ_DEVICE_KEY = "cbb-quiz-device";
export async function logQuizCompletion(nation, hybrid = null) {
  try {
    let session_id = null;
    try {
      session_id = localStorage.getItem(QUIZ_DEVICE_KEY);
      if (!session_id) {
        session_id = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`);
        localStorage.setItem(QUIZ_DEVICE_KEY, session_id);
      }
    } catch { /* no-op */ }
    const referrer = typeof window !== "undefined" ? window.location.pathname : null;
    await api.post("/quiz/complete", { nation, hybrid: hybrid || null, referrer, session_id });
  } catch { /* silent */ }
}

